import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from 'app/app.service';
import { fadeInSlideAnimation } from 'animations';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { TranslationProvider } from 'providers/translation/translation';
import { SpotData } from 'dto';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { GetServiceUrl } from 'psapp-config';
import { LoginProvider } from 'providers/login/login';
import { GeolocalizationProvider } from 'providers/geolocalization/geolocalization';

declare var window: any;

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],

    animations: [fadeInSlideAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class OverviewComponent implements OnInit {

    posList = this.domainStorageProvider.rootStore.posList;
    rankingPositions = null;
    imageService = GetServiceUrl("ImageCampaignBanner");

    swiperConfig: SwiperConfigInterface = {
        direction: 'horizontal',
        slidesPerView: 'auto',
        pagination: true,
        allowSlideNext: true,
        allowSlidePrev: true,
        loop: true
    };

    campaign: any = {
        shortName: null
    };

    bannerCampaign: any = null;

    pos: any = {
        name: null
    };

    tips: any[];

    constructor(
        private router: Router,
        public loginProvider: LoginProvider,
        public remoteService: RemoteServicesProvider,
        private appService: AppService,
        private domainStorageProvider: DomainStorageProvider,
        public translationProvider: TranslationProvider,
    ) {

    }

    async ngOnInit() {

        //reload groups
        await this.domainStorageProvider.getConfigData(false);

        this.domainStorageProvider.rootStore.selectedPOS.subscribe(pos => {
            if (pos) {
                this.pos = pos;
            }
            else{
                this.pos = { name: null };
            }
        });

        //ranking
        this.domainStorageProvider.rootStore.selectedGroupId.subscribe(async groupId => {

            if (groupId) {
                //refresh group tips, products and survey
                //await this.domainStorageProvider.rootStore.loadGroupData(groupId);

                this.rankingPositions = await this.domainStorageProvider.rootStore.getRankingPositions(groupId);
            }

            //selected campaign
            let selectedCampaign = this.domainStorageProvider.rootStore.getSelectedGroup();
            if (selectedCampaign) {
                this.campaign = selectedCampaign;
            }

            //banner campaign
            let bannerCampaign = this.domainStorageProvider.rootStore.getDefaultGroupBanner();
            if (bannerCampaign) {
                this.bannerCampaign = bannerCampaign;
            }

            //swiper tips
            this.tips = this.domainStorageProvider.rootStore.tips;

        }).unsubscribe();
    }

    showRanking(event: Event) {
        event.preventDefault();
        var contentId = this.appService.url2contentId("/show_ranking");
        window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'link', 2: 'subheader' } }]);
        this.router.navigate(["/ranking"]);
    }

    selectCampaign() {
        var contentId = this.appService.url2contentId("/campaigns");
        window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'input', 2: 'content' } }]);
        this.router.navigate(["/campaigns"]);
    }

    searchPOS() {
        var contentId = this.appService.url2contentId("/search_position");
        window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'input', 2: 'content' } }]);
        this.router.navigate(["/searchpos"]);
    }

    startCheck() {
        this.domainStorageProvider.rootStore.spotData.next(new SpotData(
            this.domainStorageProvider.rootStore.selectedPOS.value,
            this.domainStorageProvider.rootStore.getSelectedGroup()
        ));
        this.router.navigate(["/newspot"]);
    }

    gotoTips(textEngligh:String) {
        var contentId = this.appService.url2contentId("/" + textEngligh);
        window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'teaser', 2: 'content' } }]);
        this.router.navigate(["/tips"]);
    }
}
